( function( $ ) {
	let ajaxFilterdResources = undefined;
	let currentCategory = 'all';
	let currentTags = [];

	function getFilteredResources( currentEl ) {
		if ( typeof themeVars === 'undefined' ) {return;}

		if ( ajaxFilterdResources ) {
			ajaxFilterdResources.abort();
		}

		const filterContainer = $( currentEl ).parents( '.section-resources__controls' ).find( '.filter-results-block' )[0];
		const filterTagsList = $( $( filterContainer ).find( '.filter-tags-list' )[0] );

		$( currentEl ).parents( '.section-resources' ).find( '.select' ).addClass( 'disabled' );
		$( currentEl ).parents( '.section-resources' ).find( '.dropdown' ).addClass( 'disabled' );

		currentTags = [];
		filterTagsList.children().each( function() {
			currentTags.push( $( this ).attr( 'tag-id' ) );
		} );

		const formData = {
			'categoryId': currentCategory,
			'tags': currentTags
		};

		ajaxFilterdResources = $.ajax( {
			url : themeVars.ajaxurl + 'get_filtered_resources',
			data : formData,
			type : 'POST',
			dataType: 'html',
			beforeSend : function() {
				$( currentEl ).parents( '.section-resources' ).find( '.section-resources__grid-wrapper' ).addClass( 'loader-visible' );
				$( currentEl ).parents( '.section-resources' ).find( '.section-resources__grid' ).removeAttr( 'style' );
			},
		} ).done( function( response ) {
			currentEl
				.parents( '.section-resources__main' )
				.find( '.section-resources__grid' )
				.empty()
				.append( response );

			ajaxFilterdResources = undefined;

			const height = $( currentEl ).parents( '.section-resources' ).find( '.section-resources__grid' )[0].scrollHeight;
			$( currentEl ).parents( '.section-resources' ).find( '.section-resources__grid' ).css( 'max-height', height );
			$( currentEl ).parents( '.section-resources' ).find( '.section-resources__grid-wrapper' ).removeClass( 'loader-visible' );
			$( currentEl ).parents( '.section-resources' ).find( '.select' ).removeClass( 'disabled' );
			$( currentEl ).parents( '.section-resources' ).find( '.dropdown' ).removeClass( 'disabled' );

			window.resourcesReady = true;
		} ).error( function() {
			ajaxFilterdResources = undefined;
		} );
	}

	function createCustomFilter() {
		const sectionsResource = $( '.section-resources.section-resources--style-v1' );

		if ( sectionsResource.length > 0 ) {
			const defaultSelect = sectionsResource.find( '.resources-categories-select' );

			defaultSelect.each( function() {
				const _this = $( this );
				const duration = 300;

				if ( !_this.parent().hasClass( 'init' ) ) {
					const filterContent = _this.siblings( '.filter-content-resource' );
					const selectHead = filterContent.find( '.new-select' );
					const selectList = filterContent.next( '.new-select__list' );
					const selectItem = selectList.find( '.new-select__item' );
					const arrowItem = selectHead.siblings( '.icon-arrow' );
					selectList.slideUp( 0 );

					const changeSelectValue = () => {
						selectList.slideUp( duration );
						selectHead.toggleClass( 'on' );
						arrowItem.toggleClass( 'flip' );

						if ( selectHead.hasClass( 'on' ) ) {
							selectList.slideDown( duration );

							selectItem.on( 'click', function() {
								let chooseItem = currentCategory = $( this ).data( 'value' );

								defaultSelect.val( chooseItem );
								defaultSelect[0].dispatchEvent( new Event( 'change' ) );
								selectHead.text( `Categories: ${$( this ).find( 'span' ).text()}` );

								selectHead.removeClass( 'on' );
								arrowItem.removeClass( 'flip' );
								selectList.slideUp( duration );
								selectItem.off();

								getFilteredResources( filterContent.siblings( '.resources-categories-select' ) );
							} );
						}
					};

					filterContent.on( 'click', function() {
						changeSelectValue();
					} );

					$( document ).mouseup( function( e ) {
						if ( _this.parent( '.select' ).has( e.target ).length === 0 ) {
							selectHead.removeClass( 'on' );
							arrowItem.removeClass( 'flip' );
							selectList.slideUp( duration );
						}
					} );

					_this.parent().addClass( 'init' );

					window.app.main.initScrollbars( _this.parent().find( '.scrollbar-outer:not(.scroll-content)' ) );
				}
			} );
		}
	}

	const firstInitialization = async() => {
		const $section = $( '.section-resources.section-resources--style-v1' );
		await import ( 'bootstrap/js/dist/dropdown' );

		$section.each( function() {
			const $sectionInstance = $( this );

			$sectionInstance.find( '.section-resources__grid' ).each( function() {
				const height = this.scrollHeight;

				$( this ).css( 'max-height', height );
			} );

			$sectionInstance.find( '.resources-categories-select' ).each( function() {
				currentCategory = this.value.toString();
				getFilteredResources( $( this ) );
			} );

			$sectionInstance.find( '.js-resources-tag-select' ).click( function( e ) {
				e.preventDefault();
				const currentTag = $( this );
				currentTag.addClass( 'dropdown-item--selected' );

				const tagId = $( this ).data( 'tag-id' );
				const tagName = $( this ).data( 'tag-name' );
				const filterContainer = $( this ).parents( '.section-resources__controls' ).find( '.filter-results-block' )[0];
				const tagTemplate = $( $( filterContainer ).find( '.template .filter-tag' )[0] );
				const filterTagsList = $( filterContainer ).find( '.filter-tags-list' )[0];

				let existingTag = false;

				currentTags = [];

				$( filterTagsList ).children().each( function() {
					const itemTagId = $( this ).attr( 'tag-id' );
					if ( itemTagId === tagId ) {
						existingTag = true;
					}
				} );

				if ( !existingTag ) {
					tagTemplate
						.clone()
						.attr( 'tag-id', tagId )
						.appendTo( filterTagsList )
						.find( '.filter-tag__text' )
						.text( tagName ).next().click( function() {
							$( this ).parent().remove();
							currentTag.removeClass( 'dropdown-item--selected' );
							getFilteredResources( currentTag );
						} );

					getFilteredResources( $( this ) );
				}
			} );
		} );
	};

	const initBlock = function( section = false ) {
		const $section = section ? $( section ) : $( '.section-resources.section-resources--style-v1' );
		let ajaxMorePosts = undefined;

		$section.each( function() {
			const $sectionInstance = $( this );

			$sectionInstance.find( '.section-resources__grid' ).each( function() {
				const height = this.scrollHeight;

				$( this ).css( 'max-height', height );
			} );
		} );

		if ( $( '.load_more_posts' ).length > 0 && typeof themeVars !== 'undefined' ) {
			var moreButtonText = $( '.load_more_posts' ).text();


			$( '.load_more_posts' ).click( function( event ) {
				event.preventDefault();

				const $button = $( this );
				const requestUrl = $button.attr( 'href' );

				if ( ajaxMorePosts ) { return; }

				ajaxMorePosts = $.ajax( {
					url : requestUrl,
					data : {
						doing_ajax: true // eslint-disable-line
					},
					beforeSend : function() {
						$button.text( 'Loading...' );
					},
					success : function( data ) {
						ajaxMorePosts = undefined;
						$button.text( moreButtonText );
						let newPosts = $( data ).find( '#resources-grid' ).html();
						let $newButton = $( data ).find( '#resources .load_more_posts' );

						if ( newPosts ) {
							$( '#resources-grid' ).append( newPosts ); // insert new posts

							if ( $newButton.length ) {
								$button.attr( 'href',  $newButton.attr( 'href' ).replace( /\?.*$/, '' ) );
							}

							$( document.body ).trigger( 'post-load' );
						}

						if ( !$newButton.length || !newPosts ) {
							$button.remove();
						}
					},
					complete: function() {
						window.history.pushState( {}, '', requestUrl );
					},
					error : function( jqXHR, textStatus, errorThrown ) {
						ajaxMorePosts = undefined;
						$button.text( moreButtonText );
						console.log( jqXHR + ' :: ' + textStatus + ' :: ' + errorThrown );
					}
				} );
			} );
		}
	};

	const readyInitBlock = function() {
		initBlock();
		createCustomFilter();
		firstInitialization();
	};

	window.app.loadBlock( initBlock, 'section-resources', '.section-resources', false, readyInitBlock );
} )( jQuery );
